import React, {useState} from "react";
import LearnModal from "../../../GlobalComponents/LearnModal/LearnModal";
import Popup from "reactjs-popup";
import thum from "./assets/banner.png";
const Banner = () => {
  const [openBid, setOpenBid] = useState(false);
  const boxs = [
    { title: "$250M+", des: "Total Amount Vested" },
    { title: "150+", des: " Raises Completed" },
    { title: "2753", des: "DAO Members" },
    { title: "2753", des: "DAO Members" },
  ];
  return (
    <div className="pt-[30px] lg:pt-[133px]">
      <div className="container">
        <div className="max-w-[1026px] mx-auto">
          <div className="flex flex-col lg:flex-row gap-[103px]">
            <div className="w-full lg:max-w-[523px]">
              <h2 className="text-res-lg font-extrabold mb-[10px]">
                Token Vesting & Claims
              </h2>
              <p className="text-res-ls font-semibold mb-[20px]">
                Are you a proud member of R34P DAO? This is your dedicated space
                to access and claim your vested tokens from the projects funded
                by the DAO. We believe in transparency and empowering our
                community members to enjoy the full benefits of their
                investments. Stay informed and take control of your token
                allocations through our user-friendly interface.
              </p>
              <div className="flex gap-[20px]">
                <button className="text-light-black font-bold text-res-xs bg-custom-gradient w-[173px] h-[40px] rounded-[20px]">
                  Claim Now
                </button>
                <button onClick={() => setOpenBid(true)} className=" font-bold text-res-xs border  w-[173px] h-[40px] rounded-[20px]">
                  Learn More
                </button>
              </div>
            </div>
            <div>
              <img className="pt-[3px] w-full" src={thum} alt="" />
            </div>
          </div>
        </div>
        <div className="max-w-[898px] mx-auto">
          {/* =========== boxs =============*/}
          <div className="mt-[121px] flex gap-[29px] justify-center flex-wrap">
            {boxs.map((single, i) => (
              <div
                className="w-[200px] flex flex-col justify-center items-center h-[120px] bg-custom-gradient rounded-[10px]"
                key={i}
              >
                <h2 className="text-main-black text-res-sm font-black leading-[23px]">
                  {single.title}
                </h2>
                <p className="text-res-xxs leading-[23px] text-light-black font-semibold">
                  {single.des}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Popup open={openBid} position="right center">
        <div className="modalOverlay"></div>
        <LearnModal
          open={openBid}
          setOpen={setOpenBid}
        ></LearnModal>
      </Popup>
    </div>
  );
};

export default Banner;
